import ResultatsAnalysesFormTable from '@/views/analyse/resultats-analyses/saisie-resultats/components/ResultatsAnalysesFormTable';

export default {
    name: 'edit-analyse',
    components: {
        ResultatsAnalysesFormTable
    },
    props: {
        demande_id: Number,
        current_modele_analyse: Object,
        result_meta_data: Object,
        has_model: Boolean,
        add_result_loading: Boolean
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        onCloseModal() {
            this.$store.dispatch("setResultatsAnalyse", null);
            this.$refs.edit_modal_anl.click();
        },

        triggerRegistre() {
            this.onCloseModal()
            this.$emit('emitRefreshRegistre')
        }
    }
}